import { forwardRef } from "react";

const Radio = forwardRef(function Radio({ id, label, ...props }, ref) {
  return (
    <div className="flex items-center me-5">
      <input
        id={id}
        type="radio"
        className="w-5 h-5 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2"
        ref={ref}
        {...props}
      />
      <label htmlFor={id} className="ms-2">
        {label}
      </label>
    </div>
  );
});

export default Radio;
